exports.PARCEL_ACTION_CODE = {
  ALA: "ALA", // Alternative address
  DTN: "DTN", // Deliver to neighbour
  ONE: "ONE", // Precise
  RED: "RED", // Change delivery date
  SFP: "SFP", // Leave in a safe place
  TBC: "TBC", // Collect from depot
  UPG: "UPG", // Upgrade
  KMI: "KMI", // Keep me informed
  DTY: "DTY", // Duty
  REL: "REL", // re-love

  PKU: "PKU", // Collect from DPD Pickup Shop
  PKL: "PKL", // Collect from DPD Pickup Locker
  LOC: "LOC", // Delivery instructions
  ALT: "ALT", // Change address
  ALU: "ALU", // Change address & upgrade
  UPC: "UPC", // Upgrade delivery
  RTC: "RTC", // Return to sender
  WTR: "WTR", // Remove from watch list
  ALI: "ALI", // Change address
  REI: "REI", // Redeliver to same address
  RTI: "RTI", // Return to sender
  DIP: "DIP", // Dispose Request
  CME: "CME", // Call me
  WTC: "WTC", // Add to watch list
};

exports.COLLECTION_ACTION_CODE = {
  WTR: "WTR",
  CHD: "CHD",
  SFP: "SFP",
  CFN: "CFN",
  CAN: "CAN",
  INS: "INS",
  WTC: "WTC",
  REB: "REB",
};
